import Icon from './Icon';

Icon.install = function (Vue) {
  Vue.component(Icon.name, Icon);
};

export default Icon;



// WEBPACK FOOTER //
// ./src/muse-ui/Icon/index.js